import React from 'react';
import { observer } from 'mobx-react';
import { Typography } from '@mui/material';
import { useTranslation } from '@gamiphy/react-i18n';
import { useLoyaltyPageContext } from '../../context';

const WelcomeText:React.FC = () => {
  const { t } = useTranslation();
  const {
    user,
    isPreview,
  } = useLoyaltyPageContext();

  const defaultName = React.useMemo(() => (isPreview ? 'User Name' : ''), [isPreview]);

  return (
    <Typography
      variant="h1"
      sx={{
        textAlign: 'left',
      }}
    >
      { t('loyaltyPage.redeem.welcome', {
        defaultValue: 'Welcome back, {{name}}',
        name: user?.firstName ?? defaultName,
      }) }
    </Typography>
  );
};

export default observer(WelcomeText);
